<template>
  <q-dialog v-model="visible" persistent>
    <div class="hris-modal">
      <div class="hris-modal-header">
        <h2 class="hris-modal-title">Apply for Loan</h2>
      </div>
      <q-form @submit="submitForm">
        <div class="hris-modal-body">
          <div class="hris-form-row">
            <div class="hris-form-field">
              <q-select outlined dense color="green" v-model="form.loan_type" :options="loanTypeOptions" label="Loan Type"></q-select>
            </div>
            <div class="hris-form-field">
              <q-input outlined dense color="green" v-model="form.loan_amt" label="Requested Amount" type="number" lazy-rules
                :rules="[val => val > 0 || 'Required and must be > 0']"></q-input>
            </div>
          </div>

          <div class="hris-form-row">
            <div class="hris-form-field">
              <q-input outlined dense color="green" v-model="form.start_date" mask="date" label="Preferred Start Date">
                <template v-slot:append>
                  <i class="far fa-calendar-alt cursor-pointer">
                    <q-popup-proxy transition-show="scale" transition-hide="scale">
                      <q-date v-model="form.start_date">
                        <div class="row items-center justify-end">
                          <q-btn v-close-popup label="Close" flat class="hris-q-ghost"></q-btn>
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </i>
                </template>
              </q-input>
            </div>

            <div class="hris-form-field">
              <q-input outlined dense color="green" v-model="form.end_date" mask="date" label="Preferred End Date">
                <template v-slot:append>
                  <i class="far fa-calendar-alt cursor-pointer">
                    <q-popup-proxy transition-show="scale" transition-hide="scale">
                      <q-date v-model="form.end_date">
                        <div class="row items-center justify-end">
                          <q-btn v-close-popup label="Close" flat class="hris-q-ghost"></q-btn>
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </i>
                </template>
              </q-input>
            </div>
          </div>
        </div>

        <div class="hris-modal-footer">
          <q-btn unelevated label="Close" v-close-popup class="hris-q-outline"></q-btn>
          <q-btn unelevated label="Submit" type="submit" class="hris-q-primary"></q-btn>
        </div>
      </q-form>
    </div>
  </q-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    loanTypeOptions: Array
  },
  data() {
    return {
      form: {
        loan_type: '',
        loan_amt: '',
        start_date: new Date().toISOString().slice(0, 10).replace("-", "/").replace("-", "/"),
        end_date: new Date().toISOString().slice(0, 10).replace("-", "/").replace("-", "/"),
      }
    }
  },
  computed: {
    visible: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    }
  },
  methods: {
    submitForm() {
      this.$emit('submit', this.form);
    }
  }
}
</script>
